define('modules/form/form_model',[
  'backbone',
  'jquery',
  '_'


], function(Backbone, $, _) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      'action': '#',
      'cssClass': 'form'
    }
  });
  return Model;
});
